declare global {
    export interface String {
        isEmpty: () => boolean
    }
}

String.prototype.isEmpty = function isEmpty(this: string) {
    return !this || this.length <= 0
}

export { }
